import {RouteDefinition} from "../../../routes"
import {ProjectInformation} from "./ProjectEditScreen"

export const ProjectInfoRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/project-information",
        component: ProjectInformation
    }
]
